var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.999,
    height: 24,
    viewBox: "0 0 23.999 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3596",
    "data-name": "Group 3596",
    transform: "translate(-406.001 -142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3444",
    "data-name": "Path 3444",
    d: "M196.145,58.418a.462.462,0,0,0-.654,0L182.858,71.05a.465.465,0,0,0,0,.655l3.888,3.887a.462.462,0,0,0,.654,0L200.033,62.96a.464.464,0,0,0,0-.654Z",
    transform: "translate(226 87.549)",
    fill: "#293462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3445",
    "data-name": "Path 3445",
    d: "M181.718,73.268a.426.426,0,0,0-.715.2l-.982,4.1a.711.711,0,0,0,.858.858l4.1-.982a.426.426,0,0,0,.2-.715Z",
    transform: "translate(226 87.549)",
    fill: "#293462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3446",
    "data-name": "Path 3446",
    d: "M201.791,55.06a2.081,2.081,0,0,0-2.942,0L197.5,56.412a.462.462,0,0,0,0,.654l3.888,3.888a.462.462,0,0,0,.654,0l1.352-1.352a2.081,2.081,0,0,0,0-2.942Z",
    transform: "translate(226 87.549)",
    fill: "#293462"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.e8f992b2a71ab042b5131fb54d905861.svg";
export { ForwardRef as ReactComponent };